var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLockWhite = function SvgLockWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1673 7.08333H15.0007C15.9173 7.08333 16.6673 7.83333 16.6673 8.75V17.0833C16.6673 18 15.9173 18.75 15.0007 18.75H5.00065C4.08398 18.75 3.33398 18 3.33398 17.0833V8.75C3.33398 7.83333 4.08398 7.08333 5.00065 7.08333H5.83398V5.41667C5.83398 3.11667 7.70065 1.25 10.0007 1.25C12.3007 1.25 14.1673 3.11667 14.1673 5.41667V7.08333ZM10.0007 2.91667C8.61732 2.91667 7.50065 4.03333 7.50065 5.41667V7.08333H12.5007V5.41667C12.5007 4.03333 11.384 2.91667 10.0007 2.91667ZM5.00065 17.0833V8.75H15.0007V17.0833H5.00065ZM11.6673 12.9167C11.6673 13.8333 10.9173 14.5833 10.0007 14.5833C9.08398 14.5833 8.33398 13.8333 8.33398 12.9167C8.33398 12 9.08398 11.25 10.0007 11.25C10.9173 11.25 11.6673 12 11.6673 12.9167Z",
    fill: "#222222"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLockWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lock-white.4af2e693.svg";
export { ForwardRef as ReactComponent };